module.exports = __webpack_public_path__ + "img/edit-white.85b16b97.svg";